import { CSSProperties } from "react";
import { SxProps, Theme } from "@mui/material";
import { COLORS } from "../../common/constants";

type StyleKeys =
  | "dialogTitle"
  | "dialogContent"
  | "dialogActions"
  | "form"
  | "description"
  | "textField"
  | "button";

const useStyles = (): {
  [key in StyleKeys]?: CSSProperties & SxProps<Theme>;
} => ({
  dialogTitle: {
    fontSize: "18px",
    fontWeight: 600,
    color: COLORS.primary,
  },
  dialogContent: {
    padding: "0",
  },
  dialogActions: {
    justifyContent: "flex-end",
    gap: "12px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  description: {
    fontSize: "12px",
    color: "#64748b",
    marginBottom: "8px",
  },
  textField: {},
  button: {
    fontSize: "12px",
  },
});

export default useStyles;
